import React from "react";

export const ErrorMessage = ({ children }) => (
  <div className="ErrorMessage" role="alert">
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <circle cx="9" cy="9" r="8" fill="#f8d9dd" />
      <path
        d="M6 6L12 12M12 6L6 12"
        stroke="#c14953"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
    {children}
  </div>
);
